<template>
  <admin title="Licenças" menu="Licenças">
    <div class="row">
      <div class="col-lg-12 col-xs-12">
        <div class="block_info_white bg_black p-2">
          <div class="row">
            <div class="col-lg-5 col-xs-12">
              <div class="form-group mb-0 has-search">
                <input
                  type="text"
                  v-model="search"
                  v-on:keyup.enter="searchAccounts"
                  class="form-control no_border bg_grey"
                  placeholder="Search"
                />
              </div>
            </div>
            <div class="col-lg-5 col-xs-12"></div>
            <div class="col-lg-2 col-xs-12">
              <div class="pt-2">
                <span class="mr-2 color-light-grey">
                  <b>Total</b>
                </span>
                <span class="block_info">
                  <b>{{totalAccounts}}</b>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12 col-xs-12">
        <div class="row">
          <div class="col-lg-12">
            <table class="table_jovool table_jovool_dark mt-3">
              <thead class="headerTable">
                <tr class="text-center">
                  <td class="center">
                    Nome
                    <OrderTable field="recruiter_name" entity="accounts" />
                  </td>
                  <td class="center">
                    Plano
                    <OrderTable field="plan_name" entity="accounts" />
                  </td>
                  <td class="center">
                    Empresa
                    <OrderTable field="business_name" entity="accounts" />
                  </td>
                  <td class="center">
                    Data de criação
                    <OrderTable field="created_at" entity="accounts" />
                  </td>
                  <td class="center">
                    Tipo de conta
                    <OrderTable field="type_account" entity="accounts" />
                  </td>
                  <td class="center">
                    Cidade
                    <OrderTable field="created_at" entity="accounts" />
                  </td>
                  <td class="center">
                    Estado
                    <OrderTable field="state" entity="accounts" />
                  </td>
                  <td></td>
                </tr>
              </thead>
              <tbody class="position-relative">
                <tr
                  v-for="(account) in accounts"
                  :key="account.id"
                  :class="{'content-loading': loading}"
                >
                  <td class="pt-4 center">
                    <div>{{account.recruiter_name}}</div>
                  </td>
                  <td class="pt-4 center">
                    <div>{{account.plan ? account.plan.name : 'Sem plano'}}</div>
                  </td>

                  <td class="pt-4 center">
                    <div>{{account.business.name}}</div>
                  </td>
                  <td class="pt-4 center">
                    {{
                    account.created_at | moment("DD/MM/YYYY")
                    }}
                  </td>
                  <td class="pt-4 center">
                    <div>{{account.type_account}}</div>
                  </td>

                  <td class="pt-4 center">
                    <div>{{account.city}}</div>
                  </td>
                  <td class="pt-4 center">
                    <div>{{account.state}}</div>
                  </td>
                  <td>
                    <inertia-link :href="'/admins/accounts/'+account.id">
                      <font-awesome-icon :icon="['fa','pencil-alt']" class="color-light-grey"></font-awesome-icon>
                    </inertia-link>
                  </td>
                </tr>
                <div class="center position-absolute loading-gif" :class="{'d-none': !loading }">
                  <img src="/images/loading.gif" alt="loading-gif" />
                </div>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <v-pagination
      v-model="currentPage"
      :page-count="pageCount"
      class="justify-content-center mt-3"
      :class="'d-flex'"
      :classes="bootstrapPaginationClasses"
    ></v-pagination>
  </admin>
</template>

<script>
import vPagination from "vue-plain-pagination";
import OrderTable from "components/OrderTable.vue";
export default {
  components: { vPagination, OrderTable },
  data: () => ({
    search: "",
    currentPage: 1,
    pageCount: 1,
    loading: true,
    field: "",
    order: "",
    accounts: [],
    totalAccounts: 0,
    bootstrapPaginationClasses: {
      ul: "pagination",
      li: "page-item",
      liActive: "active",
      liDisable: "disabled",
      button: "page-link",
    },
  }),
  mounted() {
    setTimeout(() => {
      this.searchAccounts();
    }, 600);
    eventBus.$on("orderColumnaccounts", (fields) => {
      this.field = fields.field;
      this.order = fields.order;
      this.searchAccounts();
    });
  },
  watch: {
    currentPage: function () {
      this.searchAccounts();
    },
  },
  methods: {
    searchAccounts() {
      let params = {};

      if (this.field != "") {
        params["order"] = {};
        params["order"][this.field] = this.order;
      }
      params["search"] = this.search;
      if (this.search == "") {
        params["search"] = "*";
      }
      this.loading = true;
      axios
        .get(`/admins/accounts/search/?page=${this.currentPage}`, {
          params: params,
        })
        .then((response) => {
          this.accounts = response.data.accounts;
          this.totalAccounts = response.data.total_accounts;
          this.pageCount = Math.ceil(this.totalAccounts / 10);
          this.loading = false;
          return;
        });
    },
  },
};
</script>